import EntryProductsSection from './EntryProductsSection';

export default EntryProductsSection;
